<script lang="ts" setup>
defineProps<{
  name: string;
  classes?: string;
}>();

const getIcon = (name: string) =>
  defineAsyncComponent({
    loader: () =>
      import(`~/assets/icons/${name}.svg`).catch(() =>
        Promise.resolve({ render: () => null })
      ),
  });
</script>

<template>
  <component :is="getIcon(name)" :fontControlled="false" :class="classes" />
</template>
